import type { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { Layout } from '@/components/commons';
import React from 'react';
import { NextPageWithLayout } from '@/pages/_app';
import AboutUsContent from '@/components/aboutUs/AboutUsContent';

const AboutUsPage: NextPageWithLayout<InferGetServerSidePropsType<typeof getServerSideProps>> = () => {
  return <AboutUsContent />;
};

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
  return {
    props: {
      messages: (await import(`@/locales/${locale}.json`)).default,
    },
  };
}

AboutUsPage.getLayout = (page: React.ReactElement) => {
  return <Layout>{page}</Layout>;
};

export default AboutUsPage;
